<script>
  export let value = 0;
  export let maxValue = 200;
  export let unit = '';
  export let level = 4; // Default to level 4 (Yellow)

  const clampedValue = Math.min(Math.max(value, 0), maxValue);
  const percentage = (clampedValue / maxValue) * 100;
  
  const colors = [
    '#00843d', // Level 1 (A)
    '#59a849', // Level 2 (B)
    '#c4d635', // Level 3 (C)
    '#fff100', // Level 4 (D)
    '#f7ac1e', // Level 5 (E)
    '#ed682a', // Level 6 (F)
    '#e2001a'  // Level 7 (G)
  ];

  const color = colors[level - 1] || colors[3];
</script>

<div class="gauge-container">
  <svg viewBox="0 0 100 57" class="gauge">
    <path class="gauge-track" d="M10 50 A 40 40 0 0 1 90 50"></path>
    <path class="gauge-fill" d="M10 50 A 40 40 0 0 1 90 50" style="stroke-dasharray: {percentage * 1.256}, 125.6; stroke: {color}"></path>
  </svg>
  <div class="gauge-text">
    <span class="value">{value}</span>
    <span class="unit">{unit}</span>
  </div>
</div>

<style>
  .gauge-container {
    position: relative;
    width: 100%;
    max-width: 200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .gauge {
    width: 100%;
    transform: rotateX(180deg) rotate(180deg);
  }

  .gauge-track,
  .gauge-fill {
    fill: none;
    stroke-width: 12;
    stroke-linecap: round;
  }

  .gauge-track {
    stroke: #e6e6e6;
  }

  .gauge-fill {
    stroke: #4CAF50; /* This will be overridden by inline style */
    transition: stroke-dasharray 0.5s ease-in-out, stroke 0.5s ease-in-out;
  }

  .gauge-text {
    position: absolute;
    bottom: -10px;
    text-align: center;
    width: 100%;
  }

  .gauge-text .value {
    font-size: 1.8rem;
    font-weight: 700;
    color: #333;
    line-height: 1;
  }

  .gauge-text .unit {
    font-size: 0.8rem;
    color: #666;
    display: block;
    line-height: 1;
  }
</style>
